import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import { memo } from 'react'

import { ViewPropsCommon } from '../types'
import TopCoinsTableItem from './item'
import { StyledTable, StyledTableCell,StyledTableHead, StyledTableRow } from './styles'
import EmptyRow from './view.empty'
import LoadingRow from './view.loading'

const TopCoinsTable = ({ topCoinsData, isLoading, columns, onClickTokenItem }: ViewPropsCommon) => {
  return (
    <TableContainer data-testid="top-coins-table">
      <StyledTable>
        <StyledTableHead data-testid="top-coins-head">
          <StyledTableRow>
            {columns.map((col) => {
              return <StyledTableCell key={col.key}>{col.label}</StyledTableCell>
            })}
          </StyledTableRow>
        </StyledTableHead>

        <TableBody>
          {!isLoading &&
            topCoinsData.map((data, idx) => {
              return (
                <TopCoinsTableItem
                  data={data}
                  index={idx}
                  key={data.id}
                  columns={columns}
                  onClickTokenItem={onClickTokenItem}
                />
              )
            })}
          {!isLoading && topCoinsData.length === 0 && <EmptyRow colSpan={columns.length} />}
          {isLoading && <LoadingRow colSpan={columns.length} />}
        </TableBody>
      </StyledTable>
    </TableContainer>
  )
}

export default memo(TopCoinsTable)
